import React from 'react';

import { Box } from '@mui/material';

import { PageLayout } from 'src/components/common';
import { EmployeeMyData } from 'src/components/employee';
import { spacingStyling } from 'src/constants/spacing';
import { useScreenInfo } from 'src/hooks/common';
import { OpenDataDisputeModal } from 'src/modals/dataDispute';
import { PositionDetailsModal } from 'src/modals/position';
import type { SxProp } from 'src/types/mui';

export const ConsumerMyDataPage: React.FC = () => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return (
      <Box sx={mobileContentWrapperStyles}>
        <EmployeeMyData />

        <PositionDetailsModal />
        <OpenDataDisputeModal />
      </Box>
    );
  }

  return (
    <PageLayout titleContent="My Data" paperSx={paperStyles}>
      <EmployeeMyData />

      <PositionDetailsModal />
      <OpenDataDisputeModal />
    </PageLayout>
  );
};

const paperStyles: SxProp = {
  p: spacingStyling.myData,
};

const mobileContentWrapperStyles: SxProp = {
  zIndex: '1',
  position: 'relative',
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  p: 2,
};
